import { render, staticRenderFns } from "./order-manual-tracking-input.vue?vue&type=template&id=9567973c"
import script from "./order-manual-tracking-input.vue?vue&type=script&lang=js"
export * from "./order-manual-tracking-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports